/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />

import EmblaCarousel, {
  EmblaCarouselType,
  EmblaOptionsType,
} from 'embla-carousel'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'

export function initProductSlider(): void {
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  )
  const productSliders = Array.from(
    document.querySelectorAll('.product-slider'),
  ) as HTMLElement[]

  for (const productSlider of productSliders) {
    if (productSlider.dataset.hydrated) continue
    if (productSlider.classList.contains('product-slider--skeleton')) {
      continue
    }
    productSlider.dataset.hydrated = 'true'
    const prev = productSlider.querySelector(
      '.product-slider__controls-nav-arrow--prev',
    ) as HTMLElement | null
    const next = productSlider.querySelector(
      '.product-slider__controls-nav-arrow--next',
    ) as HTMLElement | null
    const track = productSlider.querySelector(
      '.product-slider__list-track',
    ) as HTMLElement | null
    const list = productSlider.querySelector(
      '.product-slider__list',
    ) as HTMLElement | null
    const count = productSlider.querySelector(
      '.product-slider__controls-count-current',
    ) as HTMLElement | null
    const countTotal = productSlider.querySelector(
      '.product-slider__controls-count-total',
    ) as HTMLElement | null

    if (!prev || !next || !track || !count || !countTotal || !list) {
      continue
    }

    const options: EmblaOptionsType = {
      slidesToScroll: 1,
      loop: false,
      align: 'start',
      containScroll: false,
    }

    const animationOptions = () => {
      return prefersReducedMotion.matches ? { duration: 0 } : { duration: 25 }
    }

    const emblaApi = EmblaCarousel(track, {
      ...options,
      ...animationOptions(),
    }, [WheelGesturesPlugin()])

    prefersReducedMotion.addEventListener('change', () => {
      emblaApi.reInit({
        ...options,
        ...animationOptions(),
      })
    })

    prev.addEventListener('click', () => emblaApi.scrollPrev(), false)
    next.addEventListener('click', () => emblaApi.scrollNext(), false)

    const handleSelect = () => {
      const setButtonState = (button: HTMLElement, enabled: boolean) => {
        button.toggleAttribute('disabled', !enabled)
      }
      setButtonState(prev, emblaApi.canScrollPrev())
      setButtonState(next, emblaApi.canScrollNext())

      count.innerText = (emblaApi.selectedScrollSnap() + 1).toString().padStart(
        2,
        '0',
      )
    }

    handleSelect()

    emblaApi.on('select', handleSelect)

    countTotal.innerText = list.childElementCount.toString().padStart(2, '0')
  }
}
